import styled from 'styled-components';
import sharedStyles from '../styles';
import breakpoints from '../breakpoints';

const HeaderFilters = styled.form`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: ${sharedStyles.fontWeight.light};
  align-items: center;
  justify-content: flex-end;

  @media screen and (min-width: ${breakpoints.md}) {
    border: none;
  }
`;

export default HeaderFilters;
